import React from "react";
import Chip from "@mui/material/Chip";

const COLOR_MAP = {
  success: "rgb(213, 245, 213)",
  pending: "rgb(248, 215, 218)",
};

export default function StatusChip({ label, color }) {
  return (
    <Chip
      label={label}
      size="small"
      sx={{
        fontSize: "0.75rem",
        height: "22px",
        backgroundColor: COLOR_MAP[color] || COLOR_MAP.pending,
        color: "#000",
        fontWeight: 500,
      }}
    />
  );
}
